const login = {
  en: {
    translation: {
      login: "Login",
      facebook_login: "Facebook",
      google_login: "Google",
      toc1: "Clicking on 'log in', you agree to our ",
      toc2: "Terms and Conditions",
      toc3: " and confirm to have read our ",
      toc4: "Privacy Policy",
      toc5: " and ",
      toc6: "Cookie Policy",
      toc7: ". You also state you are sixteen years old.",
      log: "Login",
      no_account_yet: "No business account yet?",
      create_it: "Create it now!",
      forgot_password: "Did you forget your password?",
      error_login: "Error",
      error_login_text: "Please check data and try again",
      change_password: "Change password",
      first_time_change_password:
        "You logged for the first time, please change your password",
      label_oldPassword: "Old password",
      label_newPassword: "New password",
      label_newPasswordRepeat: "Repeat new password",
      passwords_not_matching: "Passwords not matching",
      error_old_password: "Wrong old password",
      changed_password_succesfully:
        "You changed your password correctly, you will now be redirected",
      changed_password_succesfully_title: "Password changed",
      changed_password_error:
        "Error while trying to change password, you will now be redirected",
      changed_password_error_title: "Error change password"
    }
  },
  it: {
    translation: {
      login: "Login",
      facebook_login: "Facebook",
      google_login: "Google",
      toc1: "Cliccando su 'accedi', accetti i nostri ",
      toc2: "Termini e Condizioni",
      toc3: " e confermi di aver letto le nostre ",
      toc4: "Privacy Policy",
      toc5: " e ",
      toc6: "Cookie Policy",
      toc7: ". Dichiari altresì di aver compiuto sedici anni.",
      log: "Accedi",
      no_account_yet: "Non hai ancora un account business?",
      create_it: "Crealo ora!",
      forgot_password: "Hai dimenticato la tua password?",
      error_login: "Errore",
      error_login_text: "Per favore controlla i dati immessi e riprova",
      change_password: "Cambia password",
      first_time_change_password:
        "Ti sei loggato per la prima volta, per favore, cambia la tua password",
      label_oldPassword: "Vecchia password",
      label_newPassword: "Nuova password",
      label_newPasswordRepeat: "Ripeti nuova password",
      passwords_not_matching: "Le due password non coincidono",
      error_old_password: "Vecchia password errata",
      changed_password_succesfully:
        "Hai cambiato la tua password correttamente, adesso verrai reindirizzato",
      changed_password_succesfully_title: "Password cambiata",
      changed_password_error:
        "Errore durante il cambio password, adesso verrai reindirizzato",
      changed_password_error_title: "Errore cambio password"
    }
  }
};

export default login;



// WEBPACK FOOTER //
// ./src/Language/login.js